// extracted by mini-css-extract-plugin
export var line = "meal-planer-divider-module--line--g36+Q";
export var verticalStyle = "meal-planer-divider-module--vertical-style--Dift7";